import { CareerType } from "rivals/shared/interfaces/Career";

export default {
  emptyList: "Try selecting a different year or sport",
  emptyValue: "-",
  entryIntent: "INTENDS TO ENTER TRANSFER PORTAL",
  inTransferPortal: "IN TRANSFER PORTAL",
  noFilterResults: "Please refine your filter criteria, and try again.",
  noResults: "No results found",
  tableColumnsTitles: {
    [CareerType.COLLEGE_PLAYER]: {
      change: "CHG",
      name: "ATHLETE",
      ordinality: "#",
      originCollege: "ORIGIN COLLEGE",
      position: "POS",
      status: "STATUS"
    }
  },
  transferredTo: "TRANSFERRED TO",
  unsigned: "NEVER SIGNED",
  withdrew: "WITHDREW"
};
